










































import { Component, Vue } from 'vue-property-decorator';
import * as firebase from "firebase/app";
import "firebase/auth";

@Component
export default class Login extends Vue {
  private loading = false;
  private showError = false;
  private errorMsg = '';
  private user: { email: string; password: string} = {
    email: '',
    password: ''
  };

  auth() {
    this.loading = true;
    firebase
      .auth()
      .signInWithEmailAndPassword(this.user.email, this.user.password)
      .then(() => {
        this.loading = false;
        this.$router.push('/home')
      })
      .catch((error) => {
        this.showError = true;
        this.loading = false;
        this.errorMsg = 'Ha ocurrido un error. intenta nuevamente.';
        if (error.code == 'auth/wrong-password') this.errorMsg = 'Contraseña incorrecta';
        if (error.code == 'auth/user-not-found') this.errorMsg = 'Correo no encontrado';
        if (error.code == 'auth/invalid-email') this.errorMsg = 'El correo ingresado no es válido';
      });
  }

  created() {
    firebase.auth().onAuthStateChanged(user => {
      if (user) this.$router.push('/home');
    });
  }
}
